/** CSS 動畫時長（_modal-slide-animation.scss $modal-slide-duration: 0.35s） */
export const MODAL_SLIDE_DURATION_MS = 350;

/** 關閉動畫結束後再卸載 DOM 的緩衝（略長於 MODAL_SLIDE_DURATION_MS） */
export const MODAL_SLIDE_CLOSE_MS = 380;

/** Modal 開啟動畫結束後再量測 PerfectScrollbar（MODAL_SLIDE_DURATION_MS + buffer） */
export const MODAL_SLIDE_PS_RESYNC_MS = MODAL_SLIDE_DURATION_MS + 100;

/** 會員列表「篩選會員」等快速版（$modal-slide-fast-duration: 0.2s） */
export const MODAL_SLIDE_FAST_DURATION_MS = 200;
export const MODAL_SLIDE_FAST_CLOSE_MS = 220;

/** 預約結帳全屏面板（_appointment.scss .appointment__schedule-checkout transition: all 1s） */
export const APPOINTMENT_CHECKOUT_SLIDE_OUT_MS = 1000;

/** 銷售子頁、戰情室、退款、尾款結帳等全屏面板滑入／滑出（與預約核銷結帳一致） */
export const FULLSCREEN_PANEL_SLIDE_MS = APPOINTMENT_CHECKOUT_SLIDE_OUT_MS;
